import { EntityManager } from "./EntityManager";
import { NAMESPACE } from "./_Namespace";
import { Service } from "./Service";
import { IFullPageLoader } from "./Ui/Controls/FullPageLoader";

interface IAppVersion
{
    build: string;
    version: string;
}

interface IWindow
{
    Camera?: any;
    CodeMirror?: any;

    applicationInformation: ApplicationInformation;
    AppVersion: IAppVersion;
    chrome?: any;
    cordova?: any;
    device?: { platform: string };
    entityManager?: EntityManager;
    fullPageLoader?: IFullPageLoader;
    universalLinks: any;
}

export interface ILimits
{
    maxRequestBodySizeInBytes: number;
    multipartBodyLengthLimitInBytes: number;
    multipartHeadersLengthLimitInBytes: number;
    valueLengthLimitInBytes: number;
}

export interface ITimeZone
{
    id: string;
    description: string;
}

export interface IMicrosoftAuthenticationConfiguration
{
    applicationId: string;
    authorityBaseUrl: string;
    tenantId: string;
}

export interface IExternalAuthenticationProvidersConfiguration
{
    microsoft?: IMicrosoftAuthenticationConfiguration
}

export class ApplicationInformation
{
    public static classNamespace = NAMESPACE + "RadWindow";
    public static className = "ApplicationInformation";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    additionalConfigurationInformation?: any;
    assemblyVersions: { [name: string]: string } = {};
    authenticationData?: string;
    externalAuthenticationProviders?: IExternalAuthenticationProvidersConfiguration;
    hideFullPageLoaderForSameOriginRequests?: boolean;
    isDevelopment?: boolean;
    limits!: ILimits;
    queryStringParameters?: any;
    serverVirtualDirectory: string = "";
    timeZones!: ITimeZone[];
    virtualDirectory: string = "";
    youTubeKeys?: { [name: string]: any }
}

export class ApplicationInformationService extends Service<ApplicationInformation>
{
}

let
    radWindow: IWindow;

export const WindowShim = () =>
{
    if (!radWindow)
        radWindow = (window as any) as IWindow;

    return radWindow;
};
